
export const IbcustBaseUrl = {

    /**
     * Method to get Ibcust Base URL
     */
    get() {
        const env = window.env;
        const defaultUrl = process.env.IBCUST_BASE_URL || '';
        switch (env) {
            case 'alpha':
                return '/ibcust.proxy/alpha/ibcust';
            default:
                return defaultUrl;
        }
    }

}
